import { useEffect, useState } from "react";
import useComingSoon from "@/hooks/useComingSoon";


const GlobalPopup = () => {
  const [show, setShow] = useState(false);

  const { comingSoon } = useComingSoon();


  const imageUrl = comingSoon?.[0]?.image;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 10000); 

    return () => clearTimeout(timer);
  }, []);

  if (!show || !comingSoon || comingSoon.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex justify-center items-center">
      <div className="relative bg-white rounded-xl overflow-hidden shadow-2xl max-w-[90%]">
        {/* Close Button */}
        <button
          onClick={() => setShow(false)}
          className="absolute right-3 top-3 text-white bg-black/50 hover:bg-black/70 p-2 rounded-full"
        >
          ✕
        </button>

        {/* Your Image */}
        <img
          src={imageUrl}
          alt="Popup Banner"
          className="w-full max-h-[80vh] object-contain"
        />
      </div>
    </div>
  );
};

export default GlobalPopup;
